import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Subject, takeUntil } from 'rxjs';
import { getSelectedStore } from '../../+state/stores.selectors';
import { CustomerLoyalty } from 'src/app/stores/stores';

@Component({
  selector: 'app-profile-loyalty-points-summary',
  templateUrl: './profile-loyalty-points-summary.component.html',
  styleUrl: './profile-loyalty-points-summary.component.scss',
})
export class ProfileLoyaltyPointsSummaryComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject<void>();

  selectedStoreLocale: string;
  selectedStoreCurrency: string;
  selectedStoreCurrencySymbol: string;
  loyaltyAmountSpent: number;

  @Input() customerLoyalty: CustomerLoyalty;
  @Input() customerLoyaltyStatus: string;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.store
      .select(getSelectedStore)
      .pipe(
        takeUntil(this.unsubscribe$),
        filter((selectedStore) => !!selectedStore),
      )
      .subscribe((selectedStore) => {
        this.loyaltyAmountSpent = selectedStore.settings.LOYALTY_AMOUNT_SPENT;
        this.selectedStoreCurrencySymbol = selectedStore?.currency?.symbol;
        if (selectedStore?.address && selectedStore?.currency) {
          this.selectedStoreLocale = selectedStore.locale;
          this.selectedStoreCurrency = selectedStore.currency.isoCode;
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
